import { DashboardViewProps, PriceStatWidgetConfig, Widget } from './Widget'
import { PriceData } from '../../types/charts'
import { ArrowForward, MonetizationOn } from '@mui/icons-material'
import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import { TimeString } from '../../types/models'
import { lang } from '../../utils/lang'
import { isDebug } from '../../utils/misc'
import { nowutc } from '../../utils/time'
import { VAT } from '../../utils/vat'
import { Link } from 'react-router-dom'

export class PriceStatWidget extends Widget<{prices: PriceData[]}, PriceStatWidgetConfig> {

  get Icon() {
    return MonetizationOn
  }

  get width(): number {
    return 2
  }

  get height(): number {
    return 4
  }

  get borderRadius(): string {
    return '1.875rem'
  }

  get textColor(): string {
    return 'third.contrastText'
  }

  get bgColor(): string {
    return 'third.main'
  }

  getName(): string {
    return this.customName('Price') || this.app.t('Price')
  }

  dataUrls(): Record<string, string> {
    const country = this.app.user?.country?.iso_3166 || 'FI'
    const [from, to] = this.dateRange()
    return {
      prices: `/data/prices?from=${from}&to=${to}&area=${country}`
    }
  }

  draw(props: DashboardViewProps): React.ReactElement {
    const nowStr = nowutc().toISO() as TimeString
    const priceNow = this.data?.prices ? this.data.prices.find(line => (line.to >= nowStr && line.from < nowStr)) : null
    const country = this.app.user?.country?.iso_3166 || 'FI'
    const vat = VAT.for(country)
    const price = priceNow && priceNow.price !== null && priceNow.price !== undefined ? priceNow.price * (1 + vat) / 1000 : null

    const value = lang.num(price, isDebug('high-accuracy') ? 4 : 2, '€')

    return <Box data-cy={`box-${this.getName()}`} sx={{
      padding: '1rem 1rem 0.5rem 1rem',
    }}>
      <Typography className="big-initial" sx={{
        fontSize: '2.5rem',
        fontWeight: 600,
        lineHeight: '2.6rem',
        color: this.textColor
      }}>
        {value}
      </Typography>
      <Typography sx={{
        fontSize: '1rem',
        fontWeight: 400,
        lineHeight: '1.6rem',
        color: this.textColor
      }}>
        {this.getName()}
      </Typography>
      <Box sx={{
        mt: '0.9rem',
        display: 'grid',
        gridTemplateColumns: 'auto 1.5rem',
      }}>
        <Box sx={{
          display: 'grid',
          height: '1.8rem',
          gridTemplateColumns: 'auto auto',
          fontSize: '1rem',
        }}></Box>
        <Link to="/history/#MarketPrice">
          <ArrowForward
            sx={{ color: this.textColor }}
          />
        </Link>
      </Box>
    </Box>

  }
}
